import * as gzResponsive from './responsive.directive';

export default angular.module('gazelle.components.responsive', [
  'ngMaterial'
])
  .directive(gzResponsive.name, gzResponsive.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/responsive/responsive.module.js